<template>
  <div class="modal fade" id="modal-documents" ref="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content modal-lg">
        <form enctype="multipart/form-data" ref="form" v-on:submit.prevent="uploadFiles">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="form-group" v-if="users && users.length > 0">

              <label v-if="tab === 'driver'">Chauffeurs</label>
              <label v-if="tab === 'company'">Bedrijven</label>

              <driver-availability-multiselect
                  v-model="selectedUsers"
                  :options="users"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="false"
                  placeholder="Kies optie(s)"
                  label="name"
                  track-by="id"
                  :preselect-first="false"
                  :taggable="true"
              ></driver-availability-multiselect>
            </div>
            <div class="form-group">
              <label>Documenten</label>
              <app-dropzone :errors="errors" ref="dropzone" :sharable="tab !== 'admin'" @change="dropzoneChanged"></app-dropzone>
            </div>

            <div class="alert alert-danger" v-if="firstError">{{ firstError }}</div>
          </div>
          <!-- Modal Actions -->
          <div class="modal-footer text-left">
            <div style="width: 100%; height: 50px;">
              <button
                  type="button"
                  class="btn btn-md btn-primary pull-right"
                  @click="uploadFiles"
                  :disabled="disabled"
              >
                <span v-if="uploading" class="loading-dots">Bezig met uploaden</span>
                <span v-else><span v-if="this.$refs.dropzone">{{ this.$refs.dropzone.filelist.length }}</span> documenten toevoegen</span>
              </button>
            </div>
            <small class="pull-right">Max 20 documenten</small>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentModal',

  props: {
    title: {
      type: String,
      default: 'Documenten toevoegen',
    },

    users: {
      type: Array,
      default: []
    },

    initSelectedUsers: {
      type: Array,
      default: [],
    },

    date: {
      type: String,
      default: null
    },

    tab: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      errors: {},
      selectedUsers: [],
      emptyFileList: true,
      uploading: false,
    }
  },
  mounted() {
    this.selectedUsers = this.initSelectedUsers;

    jQuery(this.$refs.modal).modal().on('hidden.bs.modal', () => {
      this.$emit('close');
    });
  },

  computed: {
    disabled() {
      return this.uploading || this.emptyFileList;
    },

    firstError() {
      const key = Object.keys(this.errors)[0];
      if (this.errors[key]) {
        return this.errors[key][0];
      }

      return null;
    }
  },

  methods: {
    dropzoneChanged(fileList) {
      this.emptyFileList = fileList.length < 1;
    },
    uploadFiles() {
      this.uploading = true;

      const formData = new FormData;
      const files = this.$refs.dropzone.filelist;
      const filesInfo = this.$refs.dropzone.filelistInfo;

      filesInfo.names.forEach(name => {
        formData.append('names[]', name);
      });

      filesInfo.shares.forEach(shared => {
        formData.append('shared[]', shared ? 1 : 0);
      });

      files.forEach(file => {
        formData.append('files[]', file);
      });

      formData.append('tab', this.tab);

      if (this.selectedUsers && this.selectedUsers.length > 0) {
        this.selectedUsers.forEach(user => {
          formData.append('users[]', user.id);
        });
      }

      this.$http.post('/documenten', formData).then((response) => {
        this.$emit('uploaded', response.data);
        this.uploading = false;
      }, (response) => {
        this.errors = response.data.errors;
        this.uploading = false;
      });


    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/documents/DocumentModal.vue